import React, { Component } from 'react'
import { graphql } from 'gatsby'
import { Columns, Column, Container, Content, Hero, HeroBody, Subtitle, Title } from 'bloomer'
import styled from 'styled-components'

// import Breadcrumbs from '../../components/breadcrumbs'
import CallsToAction from '../../components/ctas'
import GetStarted from '../../components/start'
import Head from '../../components/head'
import Image from '../../components/image'
import Layout from '../../components/layout'
import Next from '../../components/next'

import inspectionFeatures from '../../content/features/inspection-reports'

const FeatureHighlight = styled.div`
  align-items: center;
  display: flex;
  flex-flow: column nowrap;
  height: 25rem;
  justify-content: center;
  width: 100%;

  @media only screen and (min-width: 32rem) {
    display: block;
  }
`

const ShortHeroBody = styled(HeroBody)`
  padding-top: 3rem !important;

  @media only screen and (min-width: 45rem) {
    padding-top: 9rem !important;
  }
`

const MobileMockupImage = styled(Image)`
  margin: 0 auto;

  @media only screen and (min-width: 45rem) {
    height: 75%;
    width: 75%;
  }
`

// const WebMockupImage = styled(Image)`
//   margin: 0 auto;
//   height: 100%;
//   transform: scale(1.1);
//   width: 100%;

//   @media only screen and (min-width: 45rem) {
//     transform: scale(1.5);
//   }
// `

const MockupNeighborColumn = styled(Column)`
  height: 100%;

  @media only screen and (min-width: 45rem) {
    padding-left: 8rem !important;
  }
`

const HeroImage = styled(Image)`
  left: 0;
  margin: 0 auto;
  width: 90vw;

  @media only screen and (min-width: 45rem) {
    left: -15%;
    margin: 0 auto;
    width: 80vw;
  }

  @media only screen and (min-width: 90rem) {
    width: 70vw;
  }

  @media only screen and (min-width: 120rem) {
    width: 60vw;
  }
`

class Inspection extends Component {
  render() {
    const featureHighlights = inspectionFeatures.map((feature, i) => (
      <Column key={i} isSize={{ default: 3, mobile: 'full' }}>
        <FeatureHighlight>
          <Image alt={feature.title} file={this.props.data[feature.icon]} />
          <Subtitle isSize={4} style={{ fontWeight: 700, margin: '2rem 0' }}>
            {feature.title}
          </Subtitle>
          <Content isSize={'medium'} style={{ margin: '0 1rem' }}>
            {feature.description}
          </Content>
        </FeatureHighlight>
      </Column>
    ))

    let HeroSection = (
      <Hero isColor={'light'} isSize={'medium'}>
        <ShortHeroBody>
          <Container hasTextAlign={'right'}>
            <Title hasTextAlign={'right'} isSize={1} className={'huge'}>
              {`Inspection Reports`}
            </Title>
            <Subtitle hasTextAlign={'right'} isSize={3}>
              {`Give Technicians the data driven recognition they deserve.`}
            </Subtitle>
            <CallsToAction />
          </Container>
        </ShortHeroBody>
      </Hero>
    )

    let FeatureHighlightsSection = (
      <Hero isColor={'black'} isSize={'medium'}>
        <HeroBody>
          <Container hasTextAlign={'centered'}>
            <Subtitle isSize={1}>{`Inspection Reporting Features`}</Subtitle>
            <Content isSize={'large'}>
              {`Inspections are the foundation of a company's quality assurance process, 
                since they ensure that the scope of work is being completed in a consistent manner 
                while providing the feedback necessary for your team to improve. An ideal inspection 
                report improves employee engagement by simultaneously informing your employees when 
                they are doing a great job.`}
            </Content>
            <Columns hasTextAlign={'centered'} isGrid style={{ justifyContent: 'center', marginTop: '4rem' }}>
              {featureHighlights}
            </Columns>
          </Container>
        </HeroBody>
      </Hero>
    )

    let PositiveFeedbackSection = (
      <Hero isColor={'black'} isSize={'medium'}>
        <HeroBody>
          <Container>
            <Subtitle isSize={1}>{`Bring Positive Feedback To The Forefront.`}</Subtitle>
            <Subtitle
              isSize={2}
            >{`Most Inspections are all about what your team did wrong. Change the narrative with empowering reports that showcase your team's greatness.`}</Subtitle>
            <Columns isGrid style={{ alignItems: 'flex-start' }}>
              <Column isSize={{ default: 6, mobile: 'full' }}>
                <MobileMockupImage alt={'overview screen for an inspection'} file={this.props.data.overview} />
              </Column>
              <MockupNeighborColumn isSize={{ default: 6, mobile: 'full' }}>
                <Content isSize={'large'}>
                  {`Make Inspection Reports exciting for teams with a focus on the good. Employees who feel appreciated are more receptive to working on areas where they need to make corrections.`}
                </Content>
                <ul>
                  <li>
                    <Subtitle isSize={4} style={{ fontWeight: '600' }}>
                      {`SCHEDULE INSPECTIONS`}
                    </Subtitle>
                  </li>
                  <li>
                    <Subtitle isSize={4} style={{ fontWeight: '600' }}>
                      {`USE WALKTHROUGH DATA`}
                    </Subtitle>
                  </li>
                  <li>
                    <Subtitle isSize={4} style={{ fontWeight: '600' }}>
                      {`ASSIGN AN INSPECTOR`}
                    </Subtitle>
                  </li>
                  <li>
                    <Subtitle isSize={4} style={{ fontWeight: '600' }}>
                      {`SHARE REPORTS`}
                    </Subtitle>
                  </li>
                </ul>
              </MockupNeighborColumn>
            </Columns>
          </Container>
        </HeroBody>
      </Hero>
    )

    let PictureMarkupSection = (
      <Hero isColor={'light'} isSize={'medium'}>
        <HeroBody>
          <Container>
            <Subtitle isSize={1}>{`Powerful Image Markup`}</Subtitle>
            <Subtitle isSize={2}>
              {`A Picture's worth a thousand words. Drive feedback home with photos and annotations that illustrate the message.`}
            </Subtitle>
            <Content isSize={'large'}>
              {`An Inspection Report is the perfect opportunity to educate your employees while ensuring consistent, high-quality work. Expert supervisors can spot when incorrect, underwhelming or old methods of work are occurring. Show teams precisely where they can improve with detailed notes, close up pictures and thoughtful annotations.`}
            </Content>
            <Columns isGrid style={{ display: 'flex', flexFlow: 'row nowrap' }}>
              <Column isSize={{ mobile: '1/3' }} style={{ height: '100%' }}>
                <MobileMockupImage
                  alt={'screen showing a great job being awarded during an inspection'}
                  file={this.props.data.positive}
                />
              </Column>
              <Column isSize={{ mobile: '1/3' }} style={{ height: '100%' }}>
                <MobileMockupImage alt={'mark up photos captured during an inspection'} file={this.props.data.markup} />
              </Column>
              <Column isSize={{ mobile: '1/3' }} style={{ height: '100%' }}>
                <MobileMockupImage
                  alt={'screen showing areas for improvement during an inspection'}
                  file={this.props.data.negative}
                />
              </Column>
            </Columns>
          </Container>
        </HeroBody>
      </Hero>
    )

    let SharingSection = (
      <Hero isColor={'black'} isSize={'medium'}>
        <HeroBody>
          <Container>
            <Subtitle isSize={1}>{`Easy Access, One Click Sharing`}</Subtitle>
            <Subtitle isSize={2}>Simple One-Click Sharing</Subtitle>
            <Content isSize={'large'}>
              {`Sending and Receiving Inspection Reports should be the easy part. Route's sharing tools let you send Inspections through channels your team already uses, such as Email or SMS.`}
            </Content>
            <Columns isGrid style={{ alignItems: 'center' }}>
              <Column isSize={{ default: 6, mobile: 'full' }}>
                <MobileMockupImage
                  alt={'inspection report sharing from the Route app'}
                  file={this.props.data.sharing}
                />
              </Column>
              <MockupNeighborColumn isSize={{ default: 6, mobile: 'full' }} hasTextAlign={'right'}>
                <ul>
                  <li style={{ marginBottom: '2rem' }}>
                    <Subtitle isSize={4} style={{ fontWeight: '600' }}>
                      {`REVIEW ORGANIZED INFO`}
                    </Subtitle>
                    <Content isSize={'medium'}>
                      {`Inspection Reports provide an organized breakdown of the team's performance, moving through each area where the inspector's notes are organized neatly for easy digestion.`}
                    </Content>
                  </li>
                  <li style={{ marginBottom: '2rem' }}>
                    <Subtitle isSize={4} style={{ fontWeight: '600' }}>
                      {`SHARE BY EMAIL OR SMS`}
                    </Subtitle>
                    <Content isSize={'medium'}>
                      {`Save hours of tedious work preparing your Inspection Report for sharing. Convert to PDF in one click and share away.`}
                    </Content>
                  </li>
                  <li style={{ marginBottom: '2rem' }}>
                    <Subtitle isSize={4} style={{ fontWeight: '600' }}>
                      {`STAYING AHEAD`}
                    </Subtitle>
                    <Content isSize={'medium'}>
                      {`Make sure customers are happy while handling any complaints that might head your way by sharing Inspection Reports with them. They'll love your proactive approach.`}
                    </Content>
                  </li>
                </ul>
              </MockupNeighborColumn>
            </Columns>
          </Container>
        </HeroBody>
      </Hero>
    )

    return (
      <Layout>
        <Head
          author={'Route'}
          banner={this.props.data.hero}
          title={'Inspection Reports: Perform Inspections With Route'}
          description={`The Route Platform's Inspection Reports is the ultimate tool for performing Inspections.`}
          keywords={[
            'Route',
            'inspection',
            'inspection report',
            'inspection reports for building services',
            'inspection reports for commercial cleaning',
            'inspection reports for facility maintenance',
            'inspection reports for teams',
            'SaaS',
            'software for service companies'
          ]}
          {...this.props}
        />
        {/* <Breadcrumbs {...this.props} /> */}
        {HeroSection}
        <HeroImage alt={'Route Inspection Builder Screens'} file={this.props.data.hero} />
        {FeatureHighlightsSection}
        {PositiveFeedbackSection}
        {PictureMarkupSection}
        {/* <InspectionExpectationsImage
          alt={'Meet Client Expectations with Route Inspection Reports'}
          file={this.props.data.inspectionExpectations}
        /> */}
        {SharingSection}
        <Next style={{ marginTop: '3.5rem' }} to={'/pricing-demo'} title={'Next Up: Pricing'} />
        <GetStarted />
      </Layout>
    )
  }
}

export const query = graphql`
  query InspectionQuery {
    hero: file(relativePath: { eq: "assets/hero/inspection-reports.png" }) {
      ...FluidImage
    }
    overview: file(relativePath: { eq: "assets/mockups/mobile/inspection-overview.png" }) {
      ...FluidImage
    }
    positive: file(relativePath: { eq: "assets/mockups/mobile/inspection-great-job.png" }) {
      ...FluidImage
    }
    negative: file(relativePath: { eq: "assets/mockups/mobile/inspection-lets-improve.png" }) {
      ...FluidImage
    }
    markup: file(relativePath: { eq: "assets/mockups/mobile/inspection-photo-markup.png" }) {
      ...FluidImage
    }
    sharing: file(relativePath: { eq: "assets/mockups/mobile/inspection-sharing.png" }) {
      ...FluidImage
    }
    inspectionExpectations: file(relativePath: { eq: "assets/hero/walkthrough-meet-expectations.png" }) {
      ...FluidImage
    }
    offlineFirst: file(relativePath: { eq: "assets/icons/flaticon/offline-first.png" }) {
      childImageSharp {
        fixed(width: 144, height: 144) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    greatWork: file(relativePath: { eq: "assets/icons/flaticon/great-work.png" }) {
      childImageSharp {
        fixed(width: 144, height: 144) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    photoMarkup: file(relativePath: { eq: "assets/icons/flaticon/photo-markup.png" }) {
      childImageSharp {
        fixed(width: 144, height: 144) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    oneClickSharing: file(relativePath: { eq: "assets/icons/flaticon/one-click-sharing.png" }) {
      childImageSharp {
        fixed(width: 144, height: 144) {
          ...GatsbyImageSharpFixed
        }
      }
    }
  }
`

export default Inspection
